import React from 'react'

const Clients = () => {
  return (
    <>
      <div className='client'>
        <div className='container'>
          <div className='client-text'>
            <div className='employees'>
              <span>120</span>
              <p>Awesome Employees</p>
            </div>
            <div className='employees'>
              <span>58</span>
              <p>Pizza Types</p>
            </div>
            <div className='employees'>
              <span>1468</span>
              <p>Satisfied Clients</p>
            </div>
            <div className='employees'>
              <span>2031</span>
              <p>Delivery</p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Clients